// extracted by mini-css-extract-plugin
export default {"main":"index_rem_main__e1auA","detail":"index_rem_detail__l+fZV"};